export default __webpack_public_path__ + "static/dot-pattern-2bad46a88d38ea567594a9eefba5c2d1.svg";